<div id="openlayerMap" class="openlayer-map"></div>